/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */
import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/* vite conf
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
window.Pusher = Pusher;

window.Echo = new Echo({
    broadcaster: 'reverb',
    key: import.meta.env.VITE_REVERB_APP_KEY,
    wsHost: import.meta.env.VITE_REVERB_HOST,
    wsPort: import.meta.env.VITE_REVERB_PORT ?? 80,
    wssPort: import.meta.env.VITE_REVERB_PORT ?? 443,
    forceTLS: (import.meta.env.VITE_REVERB_SCHEME ?? 'https') === 'https',
    enabledTransports: ['ws', 'wss'],
});
*/
/*
import Echo from 'laravel-echo';

window.Pusher = require('pusher-js');

window.Echo = new Echo({
    broadcaster: 'reverb',
    key: process.env.MIX_REVERB_APP_KEY,
    wsHost: process.env.MIX_REVERB_HOST,
    wsPort: process.env.MIX_REVERB_PORT ?? 80,
    wssPort: process.env.MIX_REVERB_PORT ?? 443,
    forceTLS: (process.env.MIX_REVERB_SCHEME ?? 'https') === 'https',
    enabledTransports: ['ws', 'wss'],
});

//Testing echo
window.Echo.connector.pusher.connection.bind('connecting', (payload) => {
    console.log('Websocket connecting...');
});
window.Echo.connector.pusher.connection.bind('connected', (payload) => {
    console.log('Websocket connected.', payload);
});
window.Echo.connector.pusher.connection.bind('unavailable', (payload) => {
    console.log('Websocket unavailable.', payload);
});
window.Echo.connector.pusher.connection.bind('failed', (payload) => {
    console.log('Websocket failed.', payload);
});
window.Echo.connector.pusher.connection.bind('disconnected', (payload) => {
    console.log('Websocket disconnected.', payload);
});
window.Echo.connector.pusher.connection.bind('message', (payload) => {
    console.log('Message received.', payload);
});

//channels
window.Echo.channel('messages').listen('EstadoDte', (e) =>{ console.log(e); });
*/